import styled from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(222, 226, 230);
    margin-bottom: 10px;
    border-radius: 5px;
`;

export const ResultDescription = styled.div`
  font-weight: bold;
  padding: 5px 10px;
`;

export const ResultDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #eee;
  padding: 5px 10px;
`;

export const NotificationFieldTitle = styled.div`
  font-size: 0.8em;
  color: #888;
`;

export const NotificationFieldValue = styled.div`
`;

interface NotificationFieldGroupProps {
  alignItems?: string;
}

export const NotificationFieldGroup = styled.div<NotificationFieldGroupProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: ${props => props.alignItems || 'flex-start'};
`;

export const MainInformation = styled.div`
   display: flex;
   justify-content: space-between;
   border-top: 1px solid #eee;
   padding: 5px 10px;
`;